// Only loaded for sections containing videos. Images and destination links need no JS.
if (!customElements.get('split-story-feature-video')) {
  customElements.define('split-story-feature-video', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.inView = false;
      document.addEventListener('visibilitychange', () => this.updatePlayback(), { signal });
      window.addEventListener('pageshow', () => this.updatePlayback(), { signal });
      // Retry a browser-blocked autoplay on the first interaction, without adding controls.
      document.addEventListener('pointerdown', () => this.updatePlayback(), { signal, once: true, passive: true });
      if (!('IntersectionObserver' in window)) {
        this.inView = true;
        this.updatePlayback();
        return;
      }
      this.observer = new IntersectionObserver(([entry]) => {
        this.inView = entry.isIntersecting;
        this.updatePlayback();
      }, { threshold: 0 });
      this.observer.observe(this.closest('.split-story-feature__tile'));
    }

    updatePlayback() {
      const shouldPlay = this.inView && !document.hidden;
      if (!shouldPlay) {
        this.video?.pause();
        return;
      }
      // Keep sources inert until visible, including for browsers without native video lazy loading.
      if (!this.video) {
        const media = this.querySelector('template').content.cloneNode(true);
        this.video = media.querySelector('video');
        // Set properties before insertion as well as HTML attributes for mobile autoplay.
        this.video.defaultMuted = true;
        this.video.muted = true;
        this.video.volume = 0;
        this.video.playsInline = true;
        this.video.autoplay = true;
        this.append(media);
      }
      if (!this.video.paused) return;
      this.video.play().catch(() => {
        // Device/browser restrictions can still block autoplay; retain the poster.
      });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.video?.pause();
      this.video?.remove();
      this.video = null;
    }
  });
}
